import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./components/mainsite/pages/Home";
import GalleryPhoto from "./components/mainsite/pages/GalleryPhoto";
import GalleryVideo from "./components/mainsite/pages/GalleryVideo";
import DetailPhoto from "./components/mainsite/pages/DetailPhoto";
import DetailVIdeo from "./components/mainsite/pages/DetailVIdeo";
import News from "./components/mainsite/pages/News";
import Login from "./components/mainsite/pages/Login";
import Forgot from "./components/mainsite/pages/Forgot";
import BuatPin from "./components/mainsite/pages/BuatPin";
import ChangeAccount from "./components/mainsite/pages/ChangeAccount";
import RegisterForm from "./components/mainsite/pages/RegisterForm";
import FormAlamat from "./components/mainsite/pages/FormAlamat";
import Register from "./components/mainsite/pages/Register";
import RegisterFormIndependent from "./components/mainsite/pages/RegisterFormIndependent.vue";
import TestRegister from "./components/mainsite/pages/TestRegister.vue";
import SuccessRegisterIndependent from "./components/mainsite/pages/SuccessRegisterIndependent.vue";
import CheklistJoinEvent from "./components/mainsite/pages/CheklistJoinEvent";
import Register2 from "./components/mainsite/pages/Register2";
import SuccessRegister from "./components/mainsite/pages/SuccessRegister";
import SuccessRedeem from "./components/mainsite/pages/SuccessRedeem";
import FailRedeem from "./components/mainsite/pages/FailRedeem";
import HistoryPoint from "./components/mainsite/pages/HistoryPoint";
import VerifikasiOtp from "./components/mainsite/pages/VerifikasiOtp";
import Profile from "./components/mainsite/pages/Profile";
import TukarPoin from "./components/mainsite/pages/TukarPoin";
import DetailRedeem from "./components/mainsite/pages/DetailRedeem";
import HCID from "./components/mainsite/pages/HCID";
import HCIDCARD from "./components/mainsite/pages/HCIDCARD";
import HCIDKopdar from "./components/mainsite/pages/HCIDKopdar";
import HCIDKta from "./components/mainsite/pages/HCIDKta";
import NewsDetail from "./components/mainsite/pages/NewsDetail";
import AllNews from "./components/mainsite/pages/AllNews";
import Event from "./components/mainsite/pages/Event";
import Games from "./components/mainsite/pages/Games";
import EventDetail from "./components/mainsite/pages/EventDetail";
import EventHbdFormPhone from "./components/mainsite/event/EventHbdFormPhone";
import EventHbdFormNopol from "./components/mainsite/event/EventHbdFormNopol";
import Payment from "./components/mainsite/payment/Payment";
import PaymentVirtualAccount from "./components/mainsite/payment/PaymentVa";
import ThankYouEventHbd from "./components/mainsite/event/ThankYouEventHbd";
import EventFormPage from "./components/mainsite/event/EventFormPage";
import ThankYouEvent from "./components/mainsite/event/ThankYouEvent";
import KontakPaguyuban from "./components/mainsite/pages/KontakPaguyuban";
import PaguyubanDetail from "./components/mainsite/pages/PaguyubanDetail";
import Faq from "./components/mainsite/pages/Faq";
import UpdateProfileForm from "./components/mainsite/pages/UpdateProfileForm";
import PhoneUpdate from "./components/mainsite/pages/PhoneUpdate";
import SuccessUpdateProfile from "./components/mainsite/pages/SuccessUpdateProfile";
import RegisterUserForm from "./components/mainsite/pages/RegisterUserForm";
import GameMotoGp from "./components/mainsite/pages/GameMotoGp";
import GameCbr from "./components/mainsite/pages/GameCbr";
import NoLogin from "./components/mainsite/pages/NoLogin";
import NewsletterPage from "./components/mainsite/pages/Newsletter.vue";
import NewsletterThankyou from "./components/mainsite/pages/NewsletterThankYou.vue";
import PaymentQris from "./components/mainsite/payment/PaymentQris";
import PaymentRetailOutlet from "./components/mainsite/payment/PaymentRetailOutlet";
import NongkrongBarengBarry from "./components/mainsite/pages/NongkrongBarengBarry";
import NongkrongBarengBarryThankYou from "./components/mainsite/pages/NongkrongBarengBarryThankYou.vue";
import JalurTawa from "./components/mainsite/pages/JalurTawa.vue";
import JalurTawaThankYou from "./components/mainsite/pages/JalurTawaThankYou.vue";
// ROUTE PAGES
Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/community/",
            name: "home",
            props: true,
            component: Home
        },
        // {
        // 	path: '/community/home',
        //     name: 'homepage',
        //     props: true,
        //     component: Home
        // },
        {
            path: "/community/gallery-photo",
            name: "GalleryPhoto",
            props: true,
            component: GalleryPhoto
        },
        {
            path: "/community/detail-photo",
            name: "DetailPhoto",
            props: true,
            component: DetailPhoto
        },
        //  {
        // 	path: '/community/games',
        // 	name: 'Games',
        // 	props: true,
        // 	component: Games
        // },
        {
            path: "/community/detail-video",
            name: "DetailVIdeo",
            props: true,
            component: DetailVIdeo
        },
        {
            path: "/community/gallery-video",
            name: "GalleryVideo",
            props: true,
            component: GalleryVideo
        },
        {
            path: "/community/login",
            name: "login",
            props: true,
            component: Login,
            meta: {
                guest: true
            }
        },
        {
            path: "/community/forgot",
            name: "forgot",
            props: true,
            component: Forgot,
            meta: {
                guest: true
            }
        },
        {
            path: "/community/buat-pin",
            name: "buat-pin",
            props: true,
            component: BuatPin,
            meta: {
                guest: true
            }
        },
        {
            path: "/community/register",
            name: "register",
            props: true,
            component: Register,
            meta: {
                guest: true
            }
        },
        {
            path: "/community/register2",
            name: "register2",
            props: true,
            component: Register2,
            meta: {
                guest: true
            }
        },
        {
            path: "/community/register-form",
            name: "register-form",
            props: true,
            component: RegisterForm,
            meta: {
                notregistered: true
            }
        },
        {
            path: "/community/redeem/:slug",
            name: "form-alamat",
            props: true,
            component: FormAlamat,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/success-register",
            name: "success-register",
            props: true,
            component: SuccessRegister,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/success-redeem",
            name: "success-redeem",
            props: true,
            component: SuccessRedeem,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/gagal-redeem",
            name: "gagal-redeem",
            props: true,
            component: FailRedeem,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/verifikasi-otp",
            name: "verifikasi-otp",
            props: true,
            component: VerifikasiOtp
        },
        {
            path: "/community/checklist-join-event",
            name: "checklist-join-event",
            props: true,
            component: CheklistJoinEvent,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/history-point",
            name: "history-point",
            props: true,
            component: HistoryPoint,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/profile",
            name: "profile",
            props: true,
            component: Profile,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/profile/edit-account",
            name: "edit-account",
            props: true,
            component: ChangeAccount,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/profile/edit",
            name: "edit-profile",
            props: true,
            component: UpdateProfileForm,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/phone-number",
            name: "phone-number",
            props: true,
            component: PhoneUpdate,
            meta: {
                newmembersocmed: true
            }
        },
        {
            path: "/community/success-update-profile",
            name: "success-update-profile",
            props: true,
            component: SuccessUpdateProfile
        },
        {
            path: "/community/register-user",
            name: "register-user",
            props: true,
            component: RegisterUserForm,
            meta: {
                newmember: true
            }
        },
        {
            path: "/community/tukar-poin",
            name: "tukar-poin",
            props: true,
            component: TukarPoin,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/tukar-poin/:slug",
            name: "detail-redeem",
            props: true,
            component: DetailRedeem,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/hcid",
            name: "hcid",
            props: true,
            component: HCID,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/card/:hcid",
            name: "hcid-card",
            props: true,
            component: HCIDCARD
        },
        // {
        // 	path: '/community/hcid/games/motogp',
        // 	name: 'game-motogp',
        // 	props: true,
        // 	component: GameMotoGp,
        //     meta: {
        //         requiresAuth: true
        //     }
        // }, {
        // 	path: '/community/hcid/games/racing',
        // 	name: 'game-racing',
        // 	props: true,
        // 	component: GameCbr,
        //     meta: {
        //         requiresAuth: true
        //     }
        // },
        {
            path: "/community/hcid/kopdar",
            name: "hcid-kopdar",
            props: true,
            component: HCIDKopdar,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/hcid/kta",
            name: "hcid-kta",
            props: true,
            component: HCIDKta,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/news",
            name: "News",
            props: true,
            component: News
        },
        {
            path: "/community/news-detail*",
            name: "NewsDetail",
            props: true,
            component: NewsDetail
        },
        {
            path: "/community/all-news",
            name: "AllNews",
            props: true,
            component: AllNews
        },
        {
            path: "/community/event",
            name: "Event",
            props: true,
            component: Event
        },
        {
            path: "/community/event/:slug",
            name: "EventDetail",
            props: true,
            component: EventDetail
        },
        {
            path: "/community/event/:slug/registration-hbd",
            name: "EventDetailPopup",
            props: true,
            component: EventDetail
        },
        {
            path: "/community/event/:slug/verification-phone",
            name: "EventDetailVerifikasiPhone",
            props: true,
            component: EventHbdFormPhone
        },
        {
            path: "/community/event/:slug/verification-police-number",
            name: "EventDetailVerifikasiNopol",
            props: true,
            component: EventHbdFormNopol
        },
        {
            path: "/community/event/:slug/payment",
            name: "EventPayment",
            props: true,
            component: Payment
        },
        {
            path: "/community/event/:slug/payment/virtual-account",
            name: "EventPaymentVa",
            props: true,
            component: PaymentVirtualAccount
        },
        {
            path: "/community/event/:slug/payment/qris",
            name: "EventPaymentQris",
            props: true,
            component: PaymentQris
        },
        {
            path: "/community/event/:slug/payment/retail-outlet",
            name: "EventPaymentRetailOutlet",
            props: true,
            component: PaymentRetailOutlet
        },
        {
            path: "/community/event/:slug/thank-you",
            name: "ThankYouEventHbd",
            props: true,
            component: ThankYouEventHbd
        },
        {
            path: "/community/event/:slug/:schedule/registration",
            name: "EventFormPage",
            props: true,
            component: EventFormPage
        },
        {
            path: "/community/submission-thankyou/:schedule",
            name: "ThankYouEvent",
            props: true,
            component: ThankYouEvent
        },
        {
            path: "/community/kontak-paguyuban",
            name: "KontakPaguyuban",
            props: true,
            component: KontakPaguyuban
        },
        {
            path: "/community/detail-paguyuban",
            name: "PaguyubanDetail",
            props: true,
            component: PaguyubanDetail
        },
        {
            path: "/community/faq",
            name: "Faq",
            props: true,
            component: Faq
        },
        {
            path: "/community/no-login",
            name: "no-login",
            props: true,
            component: NoLogin,
            meta: {
                noLogin: true
            }
        },
        {
            path: "/community/newsletter",
            name: "community-newsletter-popup-page",
            props: true,
            component: NewsletterPage
        },
        {
            path: "/community/newsletter/thank-you",
            name: "community-newsletter-thankyou",
            props: true,
            component: NewsletterThankyou
        },
        {
            path: "/community/newsletter/thank-you/:slug",
            name: "community-newsletter-thankyou-topic",
            props: true,
            component: NewsletterThankyou
        },
        {
            path: "/newsletter/thank-you/:slug/:subtopic",
            name: "community-newsletter-thankyou-subtopic",
            props: true,
            component: NewsletterThankyou
        },
        {
            path: "/community/register/independent",
            name: "register-form-independent",
            props: true,
            component: RegisterFormIndependent,
            meta: {
                guest: true
            }
        },
        {
            path: "/community/register/independent/success-register",
            name: "register-form-independent-success",
            props: true,
            component: SuccessRegisterIndependent,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/community/teaser/nongkrong-bareng-barry",
            name: "nongkrong-bareng-barry-teaser",
            props: true,
            component: NongkrongBarengBarry,
        },
        {
            path: "/community/teaser/nongkrong-bareng-barry/thank-you",
            name: "nongkrong-bareng-barry-teaser-thankyou",
            props: true,
            component: NongkrongBarengBarryThankYou,
        },
        {
            path: "/community/touring/jalur-tawa",
            name: "jalur-tawa-touring",
            props: true,
            component: JalurTawa,
        },
        {
            path: "/community/touring/jalur-tawa/thank-you",
            name: "jalur-tawa-touring-thankyou",
            props: true,
            component: JalurTawaThankYou,
        },
        // {
        // 	path: '/community/register/test',
        // 	name: 'register-form-test',
        // 	props: true,
        // 	component: TestRegister,
        // 	meta: {
        // 		guest: true
        // 	}
        // }
    ]
});

function getParam(param) {
    var url = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
    for (var i = 0; i < url.length; i++) {
        var params = url[i].split("=");
        if (params[0]) {
            if (params[0] == param) return params[1];
        }
    }
    return false;
}
router.beforeEach((to, from, next) => {
    //localStorage.clear();
    var member = null;
    var user = null;
    axios
        .get(api_url + "/member/profile")
        .then(response => {
            localStorage.setItem("user", JSON.stringify(response.data.data));
            var user = localStorage.getItem("user");
            if (user) {
                member = JSON.parse(user);
            }
            // console.log("NEW USER SOCMED");
            if (to.matched.some(record => record.meta.requiresAuth)) {
                if (auth) {
                    if (member.hcid == null || member.hcid == "") {
                        if (member.phone == null || member.phone == "") {
                            window.location.href = app_url + "/phone-number";
                        }
                        window.location.href = app_url + "/register-user";
                    } else {
                        next();
                    }
                } else {
                    window.location.href = app_url + "/login";
                }
            } else if (to.matched.some(record => record.meta.guest)) {
                if (auth && member) {
                    if (member.hcid == null || member.hcid == "") {
                        // console.log("NEW USER");
                        window.location.href = app_url + "/register-user";
                    } else {
                        window.location.href = app_url + "/hcid";
                    }
                } else if (auth && !member) {
                    //  window.location.href = +'/logout'
                    next();
                } else {
                    next();
                }
            } else if (to.matched.some(record => record.meta.newmembersocmed)) {
                if (auth && member) {
                    // console.log("NEW USER SOCMED");
                    if (
                        (member.hcid == null && member.phone == null) ||
                        (member.hcid == "" && member.phone == "") ||
                        (member.hcid == null && member.phone == "") ||
                        (member.hcid == "" && member.phone == null) ||
                        member.phone == null ||
                        member.phone == "" ||
                        !member.haspin
                    ) {
                        // console.log("NEW USER SOCMED NEXT");
                        next();
                    } else {
                        window.location.href = app_url + "/register-user";
                    }
                }
            } else if (to.matched.some(record => record.meta.newmember)) {
                if (auth && member) {
                    // console.log("MEMBER PHONE =  " + member.phone);
                    if (
                        (member.hcid == null && member.phone == null) ||
                        (member.hcid == "" && member.phone == "") ||
                        (member.hcid == null && member.phone == "") ||
                        (member.hcid == "" && member.phone == null)
                    ) {
                        // console.log("NEW MEMBER");
                        window.location.href = app_url + "/phone-number";
                    } else if (member.hcid == null || member.hcid == "") {
                        // console.log("HCID EMPTY");
                        next();
                    } else {
                        window.location.href = app_url + "/hcid";
                    }
                } else {
                    window.location.href = app_url + "/login";
                }
            } else if (to.matched.some(record => record.meta.notregistered)) {
                if (auth && member) {
                    if (member.hcid == null || member.hcid == "") {
                        window.location.href = app_url + "/register-user";
                    } else {
                        window.location.href = app_url + "/hcid";
                    }
                } else if (auth && !member) {
                    window.location.href = app_url + "/login";
                } else {
                    window.location.href = app_url + "/login";
                }
            } else {
                next();
            }
        })
        .catch(error => {
            console.log(error);
        });
});
export default router;
